import React from 'react';
import { Colors } from '@/styles/colors';
import { Icon } from '../Icon';
import { Button, ButtonProps } from './Button';

interface CloseButtonProps extends Pick<ButtonProps, 'className' | 'transparent' | 'onClick'> {
  color?: ValueOf<typeof Colors>;
}

export const CloseButton: React.FC<CloseButtonProps> = ({ className, color = Colors.Sienna, transparent, onClick }) => {
  return (
    <Button className={className} onClick={onClick} transparent={transparent}>
      <Icon name="CloseIcon" fillColor={color} />
    </Button>
  );
};
